<template>
  <v-menu
    v-model="showfilter"
    :close-on-content-click="false"
    min-width="400"
    nudge-right="0"
    offset-y
    content-class="popup-filter-tags"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        large
        depressed
        outlined
        :ripple="false"
        :class="btnClasses"
        v-bind="attrs"
        v-on="on"
      >
        <slot name="btn-filter" />
        <template v-if="!$slots['btn-filter']">
          <v-icon color="primary">
            filter_alt
          </v-icon>
          <span class="ml-2">{{ text }}</span>
          <v-badge
            v-if="value.length"
            color="primary"
            :content="value.length"
            inline
            class="ml-2"
          />
        </template>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <h2 class="position-relative text-h6 w-full text-center">
          Filter by Tags
        </h2>
        <v-btn
          icon
          absolute
          class="right-16"
          @click="showfilter = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-4" />
      <v-card-text class="pt-3 pb-5">
        <v-layout>
          <v-autocomplete
            :key="keyRender"
            v-model="tag"
            :items="tags.filter(t => !selected.includes(t._id))"
            :menu-props="{ maxWidth: '445px' }"
            item-value="_id"
            item-text="name"
            dense
            outlined
            hide-details
            hide-selected
            placeholder="Search tag"
            prepend-inner-icon="search"
            append-icon=""
            @change="select"
          />
        </v-layout>
        <template v-if="selected.length">
          <v-layout class="mt-5 mb-2">
            <h2 class="text-subtitle-2">
              FILTER BY TAGS
            </h2>
            <v-spacer />
            <a @click="selected = []">Remove All</a>
          </v-layout>
          <v-badge
            v-for="(tagSelected, tIndex) in selected"
            :key="tIndex"
            color="#6D7B8F"
            class="mr-1 mb-1"
            inline
          >
            <template #badge>
              <span class="mr-2">{{ tagSelected | tagName(tags) }}</span>
              <v-icon size="16" @click="remove(tIndex)">
                close
              </v-icon>
            </template>
          </v-badge>
        </template>
      </v-card-text>
      <v-divider class="mx-4" />
      <v-card-actions class="px-4 pb-5 pt-3">
        <v-spacer />
        <v-btn
          outlined
          depressed
          color="primary"
          @click="resetFilter"
        >
          Reset
        </v-btn>
        <v-btn depressed color="primary" @click="applyFilter">
          Apply Filter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'PopupFilterTags',

  filters: {
    tagName(tagId, tags) {
      const tag = tags.find(t => t._id === tagId)
      return tag && tag.name
    }
  },

  props: {
    type: {
      type: String,
      required: true,
      validate: v => ['template', 'content', 'both'].includes(v)
    },
    category: {
      type: String,
      default: ''
    },
    btnClasses: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'Filter'
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    }
  },

  data: () => ({
    tags: [],
    tag: '',
    selected: [],
    keyRender: 0,
    showfilter: false
  }),

  watch: {
    value: {
      handler(value) {
        this.selected = cloneDeep(value) || []
      },
      immediate: true
    },
    async showfilter(v) {
      if (v) {
        const params = { nopagination: true }
        if (this.category) {
          params.category = this.category
        }
        const apiUrl = {
          both: '/autocompletes/tags'
        }[this.type] || `/${this.type}-tags`
        const data = await this.$axios.$get(apiUrl, { params })
        this.tags = data.tags
      }
    }
  },

  methods: {
    select(value) {
      this.selected.push(value)
      this.tag = ''
      this.keyRender++
    },
    remove(index) {
      this.selected.splice(index, 1)
    },
    resetFilter() {
      this.showfilter = false
      this.selected = []
      this.$emit('input', [])
    },
    applyFilter() {
      this.showfilter = false
      this.$emit('input', cloneDeep(this.selected))
    }
  }
}
</script>

<style lang="scss">
.popup-filter-tags {
  .right-16 {
    right: 16px;
  }
}
</style>
